export default function () {
  const id = this.isEdit

  if (id) {
    this.doLoadItem(id)
  }
}



// WEBPACK FOOTER //
// ./src/crud/form/resources/mounted.js